<template>
  <div class="tf">
    <div class="tf-row">
      <span class="tf-label">Address</span>
      <vuetify-google-autocomplete
        ref="autocomplete"
        v-model="message_address"
        id="map"
        placeholder="Search for an address..."
        v-on:inputChange="validate"
        v-on:keydown="onKeyDown"
        :enable-geolocation="true"
        v-on:placechanged="getAddressData"
        :country="countrySelected"
        class="tf-input address-type"
      />
    </div>
  </div>
</template>
<script>
  import VuetifyGoogleAutocomplete from "vue-google-autocomplete";
  export default {
    props: {
      chat_id: {
        type: String,
        default: ""
      },
      message_send: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: Object,
        default: null
      },
      countrySelected: {
        type: Array,
        default: () => ["ca", "us"]
      }
    },
    async created() {
      const self = this;

      if (this.defaultValue && Object.keys(this.defaultValue).length > 0) {
        self.message_address = this.defaultValue.address.description;
      }

    },
    data: () => ({
      message_address: null,
      formatted_address: {},
      addressG: null,
      isValidAddress: false
    }),
    watch: {
      async message_address() {
        const self = this;
        self.setter(self.isValidAddress);
      },
      formatted_address: {
        handler(val) {
          if (val && Object.keys(val).length > 0) {
            this.setter(true);
          }
        },
        deep: true
      },
      message_send(update) {
        const self = this;
        if (update) {
          self.$refs.autocomplete.clear();
          self.isValidAddress = false;
          self.formatted_address = {};
        }
      },
      defaultValue: {
        handler(val) {
          if (val && val.address && val.address.description) {
            this.message_address = val.address.description;
          }
        },
        deep: true
      }
    },
    components: {
      VuetifyGoogleAutocomplete
    },
    methods: {
      async onKeyDown(event) {
        const self = this;
        if (event && event.key === "Enter") {
          if (self.isValidAddress && Object.keys(self.formatted_address).length > 0) {
            self.$emit("pressEnter");
          } else {
            event.preventDefault();
          }
        }
      },
      getAddressData: function (addressData, placeResultData) {
        const self = this;
        if (addressData && placeResultData) {
          self.isValidAddress = true;
          self.addressG = document.getElementById('map').value;
          self.formatted_address = {
            chat_id: self.chat_id,
            description: placeResultData.formatted_address,
            latitude: addressData.latitude,
            longitude: addressData.longitude,
            url: placeResultData.url,
            type: 'address',
          };
        }
      },
      setter(isValid) {
        const self = this;
        var param = {
          type: 'address',
          message: self.formatted_address,
          isValid: isValid,
        };

        self.$emit("setter", param);
      },

      validate() {
        const self = this;

        if (self.addressG !== document.getElementById('map').value) {
          self.isValidAddress = false;
          self.formatted_address = {};
        }
        if (!self.isValidAddress) {
          self.getAddressData(document.getElementById('map').value, () => {});
        }
      },
    },

  }
</script>
<style scoped lang="scss">
@import '../_variables';

.tf {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  > span { display: flex; flex-direction: column; gap: 6px; }
}

.tf-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  span { display: block; }
}

.tf-label {
  font-size: 10px;
  font-weight: 600;
  color: $t3;
  font-family: $font;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tf-input {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none;
  transition: border-color 0.15s;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent; }
}

// Google autocomplete input override
::v-deep .vue-google-autocomplete {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border !important;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none !important;
  box-shadow: none !important;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent !important; }
}

@media (max-width: 480px) {
  .tf { padding: 5px 8px; gap: 4px; > span { gap: 4px; } }
  .tf-label { font-size: 8px; }
  .tf-input { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
  ::v-deep .vue-google-autocomplete { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
}
@media (max-width: 360px) {
  .tf { padding: 3px 5px; gap: 3px; > span { gap: 3px; } }
  .tf-label { font-size: 7px; }
  .tf-input { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
  ::v-deep .vue-google-autocomplete { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
}
@media (max-width: 280px) {
  .tf { padding: 2px 3px; gap: 2px; > span { gap: 2px; } }
  .tf-label { font-size: 6px; }
  .tf-input { height: 18px; font-size: 8px; padding: 0 3px; }
  ::v-deep .vue-google-autocomplete { height: 18px; font-size: 8px; padding: 0 3px; }
}
</style>
